// removed by extract-text-webpack-plugin
module.exports = {"vpCampaignLandingPageContainer":"vpCampaignLandingPageContainer___1mRAI","vpCampaignLandingInnerWrapper":"vpCampaignLandingInnerWrapper___ZiYj5","vpPreviewInfo":"vpPreviewInfo___3oDMX","vpCampaignLoadingError":"vpCampaignLoadingError___3EnTr","vpSubmitSection":"vpSubmitSection___1QHCA"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CampaignLandingPage/LandingPage.module.less
// module id = 3621
// module chunks = 29